export default {
    data() {
        return {
            pending: false,
            currentPage: 1,
            perPage: null,
            totalRows: 0,
            items: [],
            search: null,
            params: {
                onlyTrashed: 0,
                ... this.$route.query
                },
            meta: {}
        };
    },
    watch: {
        currentPage: 'fetchData',
        search() {
            if (this.showPagination) {
                this.currentPage = 1;
            }

            this.fetchData();
        },
        params: {
            handler() {
                this.currentPage = 1;
                this.fetchData();
            },
            deep: true
        },
        pending(newPendingValue) {
            this.$emit('update:pending', newPendingValue);
        }
    },
    computed: {
        showPagination() {
            return (
                this.totalRows > this.perPage ||
                (this.totalRows > 0 && this.currentPage > 1)
            );
        },

        showNoResult() {
          if (this.pending) {
              return false;
          }

          if (this.lazy && !this.items.length) {
              return false;
          }

          return !this.items.length;
        },

        hasItems() {
            return this.items.length > 0;
        },

        _apiUrl() {
            return this.apiUrl || `/api/${this.resourceName}`
        }
    },
    mounted() {
        if (!this.apiUrl && !this.resourceName) {
            throw new Error('Please provide an apiUrl');
        }
        this.listenForWebsocketEvents();

        if (!this.lazy) {
            this.fetchData();
        }
    },
    methods: {
        fetchData() {
            if (this.lazy !== undefined) {
                this.lazy = false;
            }

            this.pending = true;

            this.axios
                .get(this._apiUrl, {
                    params: {
                        page: this.currentPage,
                        perPage: this.perPage,
                        search: this.search,
                        ...this.params
                    }
                })
                .then(({data}) => {
                    this.setData(data);
                })
                .catch(e => {
                    if (!e.response) {
                        throw e;
                    }
                })
                .finally(() => {
                    this.pending = false;
                });

        },

        listenForWebsocketEvents() {},

        setData(data) {
            this.items = data.data || data;
            this.meta = data.meta || {};
            this.perPage = data.per_page || this.meta.per_page
            this.totalRows = data.total || this.meta.total
        },
    },
};
